<template>
  <div class="subscribable-details">
    <h4 style="font-weight:bold;">
      {{ trans_choice('subscription.eventseries.eventseries', 1) }}: {{ subscribable.name }}
    </h4>
    <p>{{ trans('subscription.eventseries.explanation_subscribable') }}</p>

    <form class="form-horizontal row">
      <div class="col-xs-12">
        <div class="form-group">
          <label
            class="col-sm-3 control-label"
            :for="'selected_name_' + subscribableId"
          >{{ trans('core.name') }}</label>
          <div
            class="input-group col-sm-9"
            style="z-index: 0;"
          >
            <span class="input-group-addon">
              <input
                id="same_name"
                v-model="same_name"
                type="checkbox"
              >
            </span>

            <input
              :id="'selected_name_' + subscribableId"
              v-model="name"
              class="form-control"
              @input="selectValue({ attribute: 'name', value: name, same: same_name })"
            >
          </div>
        </div>

        <div class="form-group">
          <label
            class="col-sm-3 control-label"
            :for="'selected_description_' + subscribableId"
          >{{ trans('core.description') }}</label>
          <div
            class="input-group col-sm-9"
            style="z-index: 0;"
          >
            <span class="input-group-addon">
              <input
                id="same_description"
                v-model="same_description"
                type="checkbox"
              >
            </span>

            <textarea
              :id="'selected_description_' + subscribableId"
              v-model="description"
              class="form-control"
              @input="selectValue({ attribute: 'description', value: description, same: same_description })"
            />
          </div>
        </div>

        <div class="form-group">
          <label
            class="control-label col-sm-3"
            :for="'select_startdate_' + subscribableId"
          >{{
            trans('subscription.startdate_short') }}</label>
          <div
            class="input-group col-sm-9"
            style="z-index: 0;"
          >
            <span class="input-group-addon">
              <input
                id="same_startdate"
                v-model="same_startdate"
                type="checkbox"
              >
            </span>

            <query-date-picker
              :id="'select_startdate_' + subscribableId"
              v-model="startdate"
              :value="startdate"
              @input="selectValue({ attribute: 'startdate', value: startdate, same: same_startdate })"
            />
          </div>
        </div>

        <div class="form-group">
          <label
            class="control-label col-sm-3"
            :for="'select_deadline_' + subscribableId"
          >{{
            trans('subscription.deadline_short') }}</label>

          <div
            class="input-group col-sm-9"
            style="z-index: 0;"
          >
            <span class="input-group-addon">
              <input
                id="same_deadline"
                v-model="same_deadline"
                type="checkbox"
              >
            </span>

            <query-date-picker
              :id="'select_deadline' + subscribableId"
              v-model="deadline"
              :value="deadline"
              @input="selectValue({ attribute: 'deadline', value: deadline, same: same_deadline })"
            />
          </div>
        </div>

        <div class="form-group">
          <label
            class="control-label col-sm-3"
            :for="'select_groups_' + subscribableId"
          >{{ trans('subscription.groups') }}</label>
          <div
            class="input-group col-sm-9"
            style="z-index: 0;"
          >
            <span class="input-group-addon">
              <input
                id="same_groupIds"
                v-model="same_groupIds"
                type="checkbox"
              >
            </span>

            <query-magic-suggest
              :id="'select_groups_' + subscribableId"
              v-model="groupIds"
              style="z-index: 250"
              :label="trans('subscription.groups')"
              suggest_type="group"
              :value="groupIds"
              :exclude="groupIds != null && groupIds !== [] ? { 'group_id': groupIds } : {}"
              :placeholder="trans('core.type_or_click') + '...'"
              @input="selectValue({ attribute: 'groupIds', value: groupIds, same: same_groupIds })"
            />
          </div>
        </div>

        <div class="form-group">
          <label
            class="control-label col-sm-3"
            :for="'select_capacity_' + subscribableId"
          >{{
            trans('subscription.capacity') }}</label>
          <div
            class="input-group col-sm-9"
            style="z-index: 0;"
          >
            <span class="input-group-addon">
              <input
                id="same_capacity"
                v-model="same_capacity"
                type="checkbox"
              >
            </span>

            <input
              :id="'selected_capacity_' + subscribableId"
              v-model="capacity"
              class="form-control"
              type="number"
              min="1"
              @input="selectValue({ attribute: 'capacity', value: capacity, same: same_capacity })"
            >
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SelectorComponent from '../FormComponents/SelectorComponent.vue'
import QueryMagicSuggest from '../QueryMagicSuggest'
import QueryDatePicker from '../QueryDatePicker.vue'

export default {

  name: 'SubscribableParameters',
  components: { QueryMagicSuggest, QueryDatePicker, SelectorComponent },

  props: {
    subscribableId: { required: true },
  },

  data () {
    return {
      name: null,
      description: null,
      groupIds: null,
      capacity: null,
      startdate: null,
      deadline: null,
      same_name: false,
      same_description: false,
      same_groupIds: false,
      same_capacity: false,
      same_startdate: false,
      same_deadline: false,
    }
  },

  computed: {
    subscribable () {
      return this.$store.state.eventSerieSubscribables.subscribables[this.subscribableId]
    },
    allSubscribableIds () {
      return Object.keys(this.$store.state.eventSerieSubscribables.subscribables)
    },
  },

  watch: {
    subscribableId: function () {
      this.name = this.subscribable.name
      this.groupIds = this.subscribable.groupIds
      this.description = this.subscribable.description
      this.startdate = this.subscribable.startdate
      this.deadline = this.subscribable.deadline
      this.capacity = this.subscribable.capacity
    },

    same_name: function (newValue) {
      if (newValue) {
        this.selectValue({ attribute: 'name', value: this.name, same: true })
      }
    },

    same_description: function (newValue) {
      if (newValue) {
        this.selectValue({ attribute: 'description', value: this.description, same: true })
      }
    },

    same_startdate: function (newValue) {
      if (newValue) {
        this.selectValue({ attribute: 'startdate', value: this.startdate, same: true })
      }
    },

    same_deadline: function (newValue) {
      if (newValue) {
        this.selectValue({ attribute: 'deadline', value: this.deadline, same: true })
      }
    },

    same_capacity: function (newValue) {
      if (newValue) {
        this.selectValue({ attribute: 'capacity', value: this.capacity, same: true })
      }
    },

    same_groupIds: function (newValue) {
      if (newValue) {
        this.selectValue({ attribute: 'groupIds', value: this.groupIds, same: true })
      }
    },

  },

  mounted () {
    this.name = this.subscribable.name
    this.groupIds = this.subscribable.groupIds
    this.description = this.subscribable.description
    this.startdate = this.subscribable.startdate
    this.deadline = this.subscribable.deadline
    this.capacity = this.subscribable.capacity
  },

  methods: {
    selectValue ({ attribute, value, same }) {
      let subscribableIds = same ? this.allSubscribableIds : [this.subscribableId]
      this.$store.dispatch('update_subscribable', {
        subscribableIds: subscribableIds,
        name: attribute,
        value: value,
      })
      if (attribute === 'name') {
        this.$store.dispatch('update_event_cluster_labels', { event_cluster_ids: subscribableIds, label: value })
      }
    },
  },

}
</script>

<style>
    .subscribable-details {
        margin: 20px 15px;
        padding: 10px;
        border: 1px solid lightgray;
        border-left: 3px solid #25167a;
    }

    .el-date-editor {
        width: 100% !important;
    }

    .autocomplete ul{
        position:relative !important;
    }

</style>
